var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "42px",
    viewBox: "0 0 47 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconfinder_imessage-social-media_765233") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Who-We-Are",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-60.000000, -446.000000)",
    fillRule: "nonzero",
    stroke: "#555659",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_imessage-social-media_765233",
    transform: "translate(61.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,0 C10.073683,0 0,8.04381028 0,17.9664348 C0,23.0082552 2.60427849,27.5622139 6.79352175,30.8249801 C7.9841118,37.3430742 2.23054477,38.5476331 2.23054477,38.5476331 C2.23054477,38.5476331 1.51206253,39.4669131 3.29728886,39.8064474 C10.4825503,41.1160168 16.2927702,35.3513735 16.2927702,35.3513735 L16.2993579,35.2358619 C18.2699139,35.6860948 20.3485059,35.9324321 22.5,35.9324321 C34.9267562,35.9324321 45,27.8886218 45,17.9659973 C45,8.04337274 34.9267562,0 22.5,0 L22.5,0 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.0b897591cd099fca910edaab810d1f6b.svg";
export { ForwardRef as ReactComponent };